import { PageFooter, PageHeader, SiteConfig, User } from '@bepro-travel/fe.shared';
import { createContext } from 'react';

export const MainContext = createContext({
  header: undefined as PageHeader | undefined,
  setHeader: (_header?: PageHeader) => {},
  footer: undefined as PageFooter | undefined,
  setFooter: (_footer?: PageFooter) => {},
  siteConfig: undefined as SiteConfig | undefined,
  setSiteConfig: (_siteConfig?: SiteConfig) => {},
  user: undefined as User | undefined,
  setUser: (_user?: User) => {},
});
